import Button from '@/components/templates/button/Button';
import ARIcon from '@/components/templates/icons/ARIcon';
import { colors } from '@/themes/colorsMapping';
import styled from 'styled-components';

export const ModelViewerWrapper = styled.div<{ isGallery?: boolean; backgroundImage?: string }>`
  width: 100%;
  height: 100%;
  z-index: 2;
  background-image: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : 'none'};
  background-repeat: no-repeat;
  background-position: center calc(100% + 30px);
  background-size: 100%;
  max-height: ${({ isGallery }) => (isGallery ? '100%' : '500px')};
  position: relative;

  @media (min-width: 799px) {
    background-size: cover !important;
    overflow: hidden;
    border-radius: 15px;
    height: auto !important;
    aspect-ratio: 0.9;
    max-height: 100%;
    background-color: ${({ isGallery }) => (isGallery ? colors.gray : 'transparent')};
  }

  & > div {
    height: ${({ isGallery }) => (isGallery ? '100%' : '500px')};
    @media (min-width: 799px) {
      height: 100%;
    }

    model-viewer {
      width: ${({ isGallery }) => (isGallery ? '100%' : '106%')} !important;
      height: ${({ isGallery }) => (isGallery ? '100%' : '106% !important')};
      max-height: ${({ isGallery }) => (isGallery ? '100%' : '500px')};
      align-self: flex-start;
      @media (min-width: 800px) {
        align-self: center;
        width: 100% !important;
        height: 100% !important;
        max-height: none !important;
      }
    }
  }

  pod-frame-builder {
    --pod-font-family: 'futura-pt', sans-serif;
    position: relative;
    z-index: 9999;
    max-height: 60vh;
    height: 100%;
    padding-top: ${({ isGallery }) => (isGallery ? '40px' : '0')};
    @media (min-width: 799px) {
      padding-top: 0;
      max-height: 100%;
    }
  }
`;

export const CenteredUploadButton = styled(Button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
`;

export const SmallIcon = styled(ARIcon)`
  width: 23px;
  height: 23px;
`;

export const ArButton = styled.div`
  position: absolute;
  bottom: 15px;
  right: 15px;
  gap: 4px;
  margin: auto;
  background-color: #fff;
  display: flex;
  align-self: center;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  height: auto !important;
  z-index: 10000;
  padding: 6px 12px;
`;
